// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8513 ? "58474bfb" : chunkId) + "." + {"1737":"b5a2691ba2aeb212","2146":"54f2f7a75b9b6cad","7033":"64af8f802473f248","7557":"152ce2c323b44181","8513":"528a3aabb9ba4b19","9167":"cca5818fc6910926"}[chunkId] + ".js";
};